import { observer, inject } from 'mobx-react'
import _ from 'lodash'

import { FieldContainer, Title, BulletText } from '../styled'

const OtherAccounts = props => {
  return (
    <FieldContainer>
      <Title>Update the investment mix for each of the following accounts:</Title>
      {props.accounts.map(account => {
        return <BulletText key={_.uniqueId()}>{account.name}</BulletText>
      })}
    </FieldContainer>
  )
}

export default inject('store')(observer(OtherAccounts))
